import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MaxFourNumber from "Components/Input/components/MaxFourNumber";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import { getMahdoode, updateMahdoode } from "Stores/actions";
import showNotify from "Helpers/Notify";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function MahdoodeRowEditor({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    isWidth,
    isHeight,
    selectedBazsho,
    selectedBrandYaragh,
    mahdoodeDataSearch,
    mahdoodeDataPagination,
  } = useSelector((state) => ({
    isWidth: state.yaragh.isWidth,
    isHeight: state.yaragh.isHeight,
    selectedBazsho: state.yaragh.selectedBazsho,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    mahdoodeDataSearch: state.yaragh.mahdoodeDataSearch,
    mahdoodeDataPagination: state.yaragh.mahdoodeDataPagination,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [checkValid, setCheckValid] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
      auth: true,
      row: 1,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    groupPrice: {
      type: "price",
      value: row.GroupPrice,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      auth: read("StypeU") === "1",
      row: 1,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    userPrice: {
      type: "price",
      value: row.UserPrice,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      auth: read("StypeU") === "2" || read("StypeU") === "5",
      row: 1,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    minW: {
      type: "millimeter",
      value: row.MinWidth,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      auth: true,
      row: 2,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    maxW: {
      type: "millimeter",
      value: row.MaxWidth,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      auth: true,
      row: 2,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    minH: {
      type: "millimeter",
      value: row.MinHeight,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
      },
      auth: true,
      row: 2,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    maxH: {
      type: "millimeter",
      value: row.MaxHeight,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 5,
        notZero: true,
      },
      auth: true,
      row: 2,
      col: {
        sm: 6,
        xs: 12,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setChange(true);
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => {
    setShowDialog(!showDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (change) {
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        const { name, userPrice, groupPrice, minH, maxH, minW, maxW } =
          controls;
        if (
          (isWidth && +minW.value >= +maxW.value) ||
          (isHeight && +minH.value >= +maxH.value)
        ) {
          showNotify({
            text: t("minBTmax"),
            customClass: "error",
          });
        } else {
          try {
            let price;
            if (groupPrice.auth) {
              price = +groupPrice.value;
            } else {
              price = +userPrice.value;
            }
            const data = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdPop: +selectedBazsho.Id,
              Id: row.Id,
              Name: name.value,
              MinWidth: +minW.value,
              MaxWidth: +maxW.value,
              MinHeight: +minH.value,
              Maxheight: +maxH.value,
              Price: price,
            };
            await dispatch(updateMahdoode(data));
            handleDialog();
            const params = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdPop: +selectedBazsho.Id,
              Name: mahdoodeDataSearch?.Name,
              Limit: mahdoodeDataPagination.Limit,
              Page: mahdoodeDataPagination.Page,
            };
            await dispatch(getMahdoode(params));
          } catch (err) {
            console.log(err);
          }
        }
      } else {
        setCheckValid(true);
      }
    } else {
      handleDialog();
      // showNotify({
      //   text: t('noEditedItem'),
      //   customClass: "warning",
      // });
    }
    setLoading(false);
  };

  const onEnter = () => {
    onClear();
  };

  const onClear = () => {
    setCheckValid(false);
    setFormValid({
      groupPrice: true,
      minW: true,
      maxW: true,
      minH: true,
      maxH: true,
    });
    setControls({ name: { value: row.Name } });
    setControls({
      groupPrice: {
        value: +convertToEnglishNumber(row.GroupPrice.replaceAll(",", "")),
      },
    });
    setControls({
      userPrice: {
        value: +convertToEnglishNumber(row.UserPrice.replaceAll(",", "")),
      },
    });
    setControls({ minH: { value: row.MinHeight } });
    setControls({ maxH: { value: row.MaxHeight } });
    setControls({ minW: { value: row.MinWidth } });
    setControls({ maxW: { value: row.MaxWidth } });
  };
  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (selectedBrandYaragh ? selectedBrandYaragh.Disable : true) ||
          (row.IsG && read("StypeU") !== "1") ||
          read("yaraghRules")?.accessUpdate === false
        }
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="virayesh_MahdoodeYaragh" />
              {selectedBazsho && <span> ({selectedBazsho.Name})</span>}
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2} className="mt-2">
              {Object.keys(controls)
                .filter((key) => controls[key].auth && controls[key].row === 1)
                .map((key) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key}
                    >
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                        placeholder={t(key)}
                        endIcon={
                          controls[key].type === "price" ? (
                            <Translator id="moneyUnit" />
                          ) : (
                            ""
                          )
                        }
                      />
                    </Grid>
                  );
                })}
            </Grid>
            <Grid container spacing={2} className="mt-2">
              {Object.keys(controls)
                .filter(
                  (key) =>
                    controls[key].auth &&
                    controls[key].row === 2 &&
                    ((isHeight && key.includes("H")) ||
                      (isWidth && key.includes("W")))
                )
                .map((key) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key}
                    >
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        value={controls[key].value}
                        placeholder={t(key)}
                        endIcon={<Translator id="millimeter" />}
                        inputComponent={
                          controls[key].type === "millimeter" && MaxFourNumber
                        }
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  );
                })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default MahdoodeRowEditor;
